import { render, staticRenderFns } from "./LearningRecord.vue?vue&type=template&id=841d4c98&scoped=true"
import script from "./LearningRecord.vue?vue&type=script&lang=js"
export * from "./LearningRecord.vue?vue&type=script&lang=js"
import style0 from "./LearningRecord.vue?vue&type=style&index=0&id=841d4c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841d4c98",
  null
  
)

export default component.exports